'use client'

import { useGlobalHooks } from "@/common/hooks/useGlobalHooks";
import { useDocumentCursorEmitterEvents } from "@/common/hooks/useDocumentCursorEmitterEvents";
import { useUserApiEventSource } from "@/common/hooks/event-source/useUserApiEventSource.ts";
import useKeyboardShortcutOpenShortcutInfoModal from "@/common/hooks/useKeyboardShortcutOpenShortcutInfoModal.ts";

export default function GlobalHooksProvider() {
  useGlobalHooks()
  useDocumentCursorEmitterEvents()
  useUserApiEventSource()
  // useBandWorkspaceApiEventSource()
  useKeyboardShortcutOpenShortcutInfoModal();

  return null
}
